/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import { TableCell, Checkbox, FormControlLabel } from '@mui/material';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2C313D',
    color: theme.palette.common.white,
    border: 0,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    border: 0,
  },
}));

export const CheckboxCell = (props) => {
  return (
    <StyledTableCell
      key={props.index}
      scope={props.scope}
      align={props.align}
      padding="checkbox"
    >
      <FormControlLabel
        sx={{ ml: 1 }}
        disabled
        control={
          <Checkbox
            checked={props.checked}
            onChange={props.onChange}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        }
      />
      {props.value}
    </StyledTableCell>
  );
};
